/**
 * get the current device breakpoint
 * based on _breakpoints.scss
 *
 */
exports.getResponsiveTag = function () {
	var tag = window.getComputedStyle(document.body, ':after').getPropertyValue('content')
	tag = tag.replace(/"/g, '').replace(/'/g, '')
	return tag
}



// WEBPACK FOOTER //
// ./src/utils/index.js